export const firebaseConfig = {
  apiKey: "AIzaSyACeSmPVO_d31w3ZZ7BYjOaBIQP0gvVvYQ",
  authDomain: "stad-hunt.firebaseapp.com",
  projectId: "stad-hunt",
  storageBucket: "stad-hunt.appspot.com",
  messagingSenderId: "877479106108",
  appId: "1:877479106108:web:c912bae72ddb4180205539",
  databaseURL: "https://dh2642-9c100.eur3.firebasedatabase.app",
};
